<div class="button-wrapper">
  <div class="return-wrapper">
    <a [routerLink]="['../../']" class="return"><i id="icon-chevron" class="fas fa-chevron-left"></i> {{'BACK' | translate}}</a>
  </div>
</div>

<article class="form-wrapper">
  <form class="profile-form" [formGroup]="editForm" (ngSubmit)="onEdit()">
    <div class="name-wrapper">
      <div class="first-name-wrapper">
        <label for="first-name">{{ 'FIRST_NAME' | translate }}</label>
        <input id="first-name" type="text" class="profile-field" formControlName="firstName" [placeholder]="'FIRST_NAME' | translate" />
        <p *ngIf="editForm.get('firstName')!.invalid && invalidSubmission" class="warning">{{'ENTER_A_FIRST_NAME' | translate}}</p>
      </div>
      <div class="last-name-wrapper">
        <label for="last-name">{{ 'LAST_NAME' | translate }}</label>
        <input id="last-name" type="text" class="profile-field" formControlName="lastName" [placeholder]="'LAST_NAME' | translate" />
        <p *ngIf="editForm.get('lastName')!.invalid && invalidSubmission" class="warning">{{'ENTER_A_LAST_NAME' | translate}}</p>
      </div>
    </div>

    <label for="email">{{ 'EMAIL' | translate }}</label>
    <input id="email" type="text" class="profile-field" formControlName="email" [placeholder]="'EMAIL' | translate" />
    <p *ngIf="editForm.get('email')!.invalid && invalidSubmission" class="warning">{{'ENTER_AN_EMAIL_ADDRESS' | translate}}</p>

    <label for="language">{{'LANGUAGE' | translate}}</label>
    <select id="language" formControlName="language">
      <option [ngValue]="null" disabled>{{ 'SELECT_A_LANGUAGE' | translate }}</option>
      <option [ngValue]="language" *ngFor="let language of languages; first as firstElement">{{ language | translate}}</option>
    </select>
    <label for="language">{{'ACTIVE' | translate}}</label>
    <select id="is-active" formControlName="isActive">
      <option [value]="true">{{ 'YES' | translate }}</option>
      <option [value]="false">{{ 'NO' | translate }}</option>
    </select>
    <button class="edit-button">{{'SAVE' | translate}}</button>
  </form>
</article>
